import './sendVideo.scss';

export const SendVideoTemplate = (model) => {
	const { videoUrl, captions, id, errorMessage, platform } = model;

	const trackHTML = captions ? `<track default label="Captions" src="${captions}" kind="captions">` : '';
	/* html */
	let html = '';

	if (platform === 'vimeo') {
		const data = videoUrl.substr(videoUrl.length - 9);
		html += `<iframe src="https://player.vimeo.com/video/${data}" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
	} else if (platform === 'youtube') {
		const data = videoUrl.substr(videoUrl.length - 11);
		html += `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${data}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
	} else if (platform === 'facebook') {
		html += `<iframe src="https://www.facebook.com/plugins/video.php?href=${videoUrl}&show_text=0&width=560" width="100%" height="100%" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allowFullScreen="true"></iframe>`;
	} else if (platform === 'video') {
		html += `
        <video preload="auto" aria-label="video" class="engt-video-msg" tabindex="0" onkeydown="ENGT_CHAT.onEnterPress()"
            style="cursor: pointer;" id="engtVideo-${id}"  disablepictureinpicture controlslist="nofullscreen noremoteplayback noplaybackrate">
            <source id="src-${id}" src="${videoUrl}" type="video/mp4">
            ${trackHTML}
        </video>`;
	} else {
		html += errorMessage;
	}
	/* html */

	return html;
};
